import { QueryClient } from '@tanstack/react-query';

// Shared query client reference for invalidating token balance from the store
let _queryClient: QueryClient | null = null;

export function setChatStoreQueryClient(qc: QueryClient) {
  _queryClient = qc;
}

export function getChatStoreQueryClient(): QueryClient | null {
  return _queryClient;
}
